import { fetchAttachmentsQuery } from '../api/restQueries';
import { ATTACHMENT_QUERY_SOURCE, SHOW_MORE_INCREMENT } from '../constants/constants';

// This function primes the data in the cache for the card, we do not reference the returned value
export function fetchAttachmentsCardData(clients, requestContext) {
  const {
    objectTypeId,
    objectId
  } = requestContext.additionalLocationData;
  if (!objectTypeId || !objectId) {
    return Promise.resolve(undefined);
  }
  return clients.dfcClient.query({
    query: fetchAttachmentsQuery,
    variables: {
      objectTypeId,
      objectId: objectId.toString(),
      origin: ATTACHMENT_QUERY_SOURCE.CARD,
      count: SHOW_MORE_INCREMENT,
      offset: 0,
      shouldBustCache: false
    }
  });
}